
import { supabase } from "@/integrations/supabase/client";

export const useCreateDemoAdmin = () => {
  const createDemoAdminIfNeeded = async () => {
    try {
      const adminEmail = 'admin@instamg.com';
      const adminPassword = 'Admin123!';
      
      const { data: existingUser, error: checkError } = await supabase.auth.signInWithPassword({
        email: adminEmail,
        password: adminPassword
      });
      
      if (existingUser.user) {
        console.log('Demo admin account already exists');
        await supabase.auth.signOut();
        return;
      }
      
      const { data: authData, error: signUpError } = await supabase.auth.signUp({
        email: adminEmail,
        password: adminPassword,
        options: {
          data: {
            first_name: 'Admin',
            last_name: 'User',
            phone: '1234567890',
            role: 'admin'
          },
        },
      });

      if (signUpError) {
        console.error('Error creating demo admin user:', signUpError);
        return;
      }

      console.log('Demo admin user created successfully');
    } catch (error) {
      console.error('Error in createDemoAdminIfNeeded:', error);
    }
  };

  return { createDemoAdminIfNeeded };
};
